<template>
  <CRow class="mainContainer bg-white">
    <!--      :show.sync="this.$store.getters.dialogOTPHolderGetter"-->
    <CModal
      :centered="true"
      :show.sync="otpModal"
      add-content-classes="bgmodalmdl"
      :closeOnBackdrop="false"
    >
      <template #body-wrapper>
        <div class="modal-text">
          <div class="p-3 mt-3">
            <h1 class="ml-4 mt-3">Change Password</h1>
            <input
              class="underlineforgot ml-4 mt-3"
              placeholder="Fill your verify code from your registered e-mail"
              style="padding-bottom: 0px;padding-top: 0px;padding-left: 0px;padding-right: 0px;"
              v-model="otpInput"
            />
            <CButton @click="checkOTPInput" class="btnforgot mt-3"
              >Summit</CButton
            >
          </div>
        </div>
      </template>
      <template #header-wrapper>
        <div></div>
      </template>
      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>
    <CModal add-content-classes="bgmodalmdl" :show.sync="modalWarning" centered>
      <template #body-wrapper>
        <div class="modal-text">
          <div class="p-3 mt-3">
            <h1 class="ml-4 mt-3">NOTICE !</h1>
            <p style="text-align: justify; text-indent: 30px; margin-top:20px">
              Can not change password for student and teacher in MDL system.
              Please contact the division of registrar to complete the changing process or call 053-9999999
            </p>
            <CButton @click="modalWarning = false" class="btnforgot mt-3"
              >Summit</CButton
            >
          </div>
        </div>
      </template>
      <template #header-wrapper>
        <div></div>
      </template>
      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>
    <CModal
      :centered="true"
      :show.sync="completeModal"
      add-content-classes="bg-transparent border-0"
      :closeOnBackdrop="false"
    >
      <template #header-wrapper>
        <div @click="completeModal = false" class="closeBtnContainer">
          <p class="closeButton">
            <img
              @click="completeModal = false"
              src="@/assets/icons/closeButton.svg"
              style="background-color: white; border-radius: 50%;"
            />
          </p>
        </div>
      </template>
      <template #body-wrapper>
        <div class="completeContainer">
          <CCol style="align-items: center">
            <CRow class="title">
              <label class="textButtonFont" style="font-weight: bold">{{
                completeTitle
              }}</label>
            </CRow>
            <CRow class="content">
              <label class="textButtonFont">{{ completeText }}</label>
            </CRow>
            <CRow class="completeButton">
              <CButton
                @click="acceptConfirm"
                class="textButtonFont"
                style="border-radius: 24px;width: 40%;background-color: #0080FF;color: white;font-weight: bold"
                >OK</CButton
              >
            </CRow>
          </CCol>
        </div>
      </template>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>

    <CRow class="changePasswordContainer">
      <CCol class="mt-5" style="display: block;">
        <CRow>
          <label class="displayText">{{
            mdlText.changePassword.current.title[1].val
          }}</label>
        </CRow>
        <CRow>
          <input
            class="border-bottom bg-transparent underline"
            placeholder="Enter your current password"
            type="password"
            v-model="currentPassword"
          />
        </CRow>
        <CRow class="mt-3">
          <label class="displayText">New Password</label>
        </CRow>
        <CRow class="input-container passwordUnderline">
          <CCol class="text-left nonePaddingHorizontal" col="10">
            <input
              :type="newPasswordType"
              @input="new_password"
              class="underline"
              placeholder="Enter your new password"
              v-model="newPassword"
            />
          </CCol>
          <CCol class="text-right p-0" col="2">
            <img
              @click="showNewPassword"
              src="@/assets/icons/showpassword.svg"
              style="cursor:pointer;"
              type="password"
            />
          </CCol>
        </CRow>
        <CRow class="lnu_container nonePaddingHorizontal">
          <CCol class="strong">
            <p v-bind:class="{ lovercase_valid: new_contains_lovercase }">
              Lowercase
            </p>
          </CCol>
          <CCol class="strong">
            <p v-bind:class="{ uppercase_valid: new_contains_uppercase }">
              Uppercase
            </p>
          </CCol>
          <CCol class="strong">
            <p v-bind:class="{ number_valid: new_contains_number }">Number</p>
          </CCol>
          <CCol class="strong">
            <p v-bind:class="{ uppercase_valid: new_valid_password_length }">
              More than 7
            </p>
          </CCol>
        </CRow>
        <CRow>
          <label class="displayText">Confirm Password</label>
        </CRow>
        <CRow class="input-container passwordUnderline">
          <CCol class="text-left nonePaddingHorizontal" col="10">
            <input
              :type="confirmPasswordType"
              @input="confirm_password"
              class="underline"
              placeholder="Enter your confirm new password"
              v-model="confirmPassword"
            />
          </CCol>
          <CCol class="text-right p-0" col="2">
            <img
              @click="showConfirmPassword"
              src="@/assets/icons/showpassword.svg"
              style="cursor:pointer;"
              type="password"
            />
          </CCol>
        </CRow>
        <CRow>
          <label class="passwordMatched" v-if="this.passwordMatch">{{
            this.warningText
          }}</label>
          <label
            class="passwordMatched text-danger"
            v-if="!this.passwordMatch"
            >{{ this.warningText }}</label
          >
        </CRow>

        <CRow class="mt-5 mb-5">
          <CCol class="text-right" col="6">
            <CButton class="cancelButton">
              <strong>CANCEL</strong>
            </CButton>
          </CCol>
          <CCol class="text-left" col="6">
            <CButton
              :disabled="
                !this.newPassword ||
                  !this.currentPassword ||
                  !this.confirmPassword ||
                  !this.new_contains_lovercase ||
                  !this.new_contains_uppercase ||
                  !this.new_contains_number ||
                  !this.new_valid_password_length ||
                  this.newPassword !== this.confirmPassword
              "
              @click="updateFunction"
              class="updateButton"
            >
              <strong>UPDATE</strong>
            </CButton>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </CRow>
</template>

<script>
import Service from "../../service/api";
import mdlData from "../../assets/json/mdl.json";

export default {
  data() {
    return {
      mdlText: mdlData,
      completeModal: false,
      otpModal: false,
      completeText: "A",
      completeTitle: "A",
      secretToVerifyOTP: "",
      otpInput: "",
      currentPassword: "",
      newPassword: null,
      new_password_length: 0,
      new_contains_lovercase: false,
      new_contains_number: false,
      new_contains_uppercase: false,
      new_valid_password_length: false,
      new_valid_password: false,
      newPasswordType: "password",

      confirmPassword: null,
      confirm_password_length: 0,
      confirm_contains_lovercase: false,
      confirm_contains_number: false,
      confirm_contains_uppercase: false,
      confirm_valid_password_length: false,
      confirm_valid_password: false,
      confirmPasswordType: "password",
      passwordMatch: false,
      warningText: "",
      modalWarning: false,
    };
  },
  watch: {
    confirmPassword(value) {
      if (this.newPassword === value) {
        this.warningText = "Password matched!!";
        this.passwordMatch = true;
      } else {
        this.warningText = "Password not matched!!";
        this.passwordMatch = false;
      }
    },
    newPassword(value) {
      if (this.confirmPassword === value && this.confirmPassword !== null) {
        this.warningText = "Password matched!!";
        this.passwordMatch = true;
      } else if (
        this.confirmPassword !== value &&
        this.confirmPassword !== null
      ) {
        this.warningText = "Password not matched!!";
        this.passwordMatch = false;
      }
    },
  },

  methods: {
    new_password: function() {
      this.new_password_length = this.newPassword.length;
      if (this.new_password_length > 7) {
        this.new_valid_password_length = true;
      } else {
        this.new_valid_password_length = false;
      }

      this.new_contains_lovercase = /[a-z]/.test(this.newPassword);
      this.new_contains_number = /\d/.test(this.newPassword);
      this.new_contains_uppercase = /[A-Z]/.test(this.newPassword);

      // Check if the password is valid
      if (
        this.new_contains_lovercase == true &&
        this.new_contains_number == true
      ) {
        this.new_valid_password = false;
        if (
          this.new_contains_uppercase == true &&
          this.new_valid_password_length == true
        )
          this.new_valid_password = true;
      } else {
        this.new_valid_password = false;
      }
    },
    confirm_password: function() {
      this.confirm_password_length = this.confirmPassword.length;
      if (this.confirm_password_length > 7) {
        this.confirm_valid_password_length = true;
      } else {
        this.confirm_valid_password_length = false;
      }

      this.confirm_contains_lovercase = /[a-z]/.test(this.confirmPassword);
      this.confirm_contains_number = /\d/.test(this.confirmPassword);
      this.confirm_contains_uppercase = /[A-Z]/.test(this.confirmPassword);

      // Check if the password is valid
      if (
        this.confirm_contains_lovercase == true &&
        this.confirm_contains_number == true
      ) {
        this.confirm_valid_password = false;
        if (
          this.confirm_contains_uppercase == true &&
          this.confirm_valid_password_length == true
        )
          this.confirm_valid_password = true;
      } else {
        this.confirm_valid_password = false;
      }
    },
    showNewPassword() {
      this.newPasswordType =
        this.newPasswordType === "password" ? "text" : "password";
    },
    showConfirmPassword() {
      this.confirmPasswordType =
        this.confirmPasswordType === "password" ? "text" : "password";
    },
    updateFunction() {
      if (
        this.$store.getters["profile/getUserType"] == 10 ||
        this.$store.getters["profile/getUserType"] == 20
      ) {
        this.modalWarning = true;
      } else {
        this.otpModal = true;
        Service.onSendOTP({
          username: this.$store.getters["profile/getProfile"].userinfo.email
            .name,
        })
          .then((res) => {
            this.secretToVerifyOTP = res.data.secret;
          })
          .catch((err) => {});
      }
    },
    checkOTPInput() {
      this.otpModal = false;
      let body = {
        token: this.otpInput,
        secret: this.secretToVerifyOTP,
        newPassword: this.newPassword,
      };
      Service.onResetPassword(body)
        .then((res) => {
          this.completeText = "Changing your password is completed";
          this.completeTitle = "COMPLETE!";
          this.completeModal = true;
        })
        .catch((err) => {
          this.completeText = "Changing your password is not completed";
          this.completeTitle = "SOMETHING WRONG!";
          this.completeModal = true;
        });
    },
    acceptConfirm() {
      this.completeModal = false;
      if (this.completeTitle === "SOMETHING WRONG!") {
        this.otpModal = true;
      } else {
        this.$store.dispatch("auth/logout");
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");

.title {
  color: black;
  justify-content: center;
  font-family: Roboto;
  margin-bottom: 0.8rem;
  font-size: 1.28rem;
}

.content {
  color: black;
  justify-content: center;
  font-family: Roboto;
  font-weight: 400;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.completeButton {
  justify-content: center;
}
.completeContainer {
  width: 80%;
  border-radius: 20px;
  background-color: white;
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
  align-self: center;
}
.closeButton {
  align-content: flex-end;
  float: right;
  width: 26px;
  height: 26px;
  padding-top: -100px;
  margin-right: 12px;
  cursor: pointer;
  margin-bottom: 0.1em;
}
.closeBtnContainer {
  padding-right: 1rem;
}
.modal-text-success h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: black;
  text-align: center;
}

.modal-text-success p {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-size: 16px;
  color: black;
  text-align: center;
}

.modal-text h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: black;
  text-align: left;
}

.modal-text p {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-size: 16px;
  color: black;
  text-align: left;
}

.bgmodalmdl {
  border-radius: 30px;
  width: 100%;
}

.btnforgot {
  display: block;
  background-color: #0080ff;
  width: 173px;
  border-radius: 30px;
  padding-left: auto;
  color: white;
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  text-align: center;
  margin: 0 auto;
}
.closeButtonItem {
  background-color: white;
  border-radius: 50%;
}
.underlineforgot {
  border: 0;
  outline: 0;
  background: transparent;
  width: 90%;
  border-bottom: 0.5px solid #cccccc;
}

.underline {
  border: 0;
  outline: 0;
  background: transparent;
  width: 100%;
}

.input_container {
  display: block;
  margin: 0 auto;
  width: 320px;
  height: auto;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

#app input[type="password"] {
  width: 320px;
  height: auto;
  border: 1px solid transparent;
  background: #eeeeee;
  color: #475762;
  font-size: 15px;
  border-radius: 4px;
  padding: 12px 5px;
  overflow: hidden;
  outline: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}

.password_length {
  padding: 2px 10px;
  position: absolute;
  top: 50%;
  right: 10px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #fbd490;
  color: rgba(71, 87, 98, 0.8);
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.closeBtnContainer {
  padding-right: 1rem;
}

.lnu_container {
  margin-top: 0.5rem;
  width: 108%;
  height: auto;
  display: flex;
  /*justify-content: space-between;*/
}

.lnu_container p {
  width: 100%;
  font-size: 10.7px;
  line-height: 2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 99, 0.8);
  background: linear-gradient(to right, #0080ff 50%, #eee 50%);
  background-size: 201% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.closeButtonItem {
  background-color: white;
  border-radius: 50%;
}
.lovercase_valid,
.number_valid,
.uppercase_valid {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

.mainContainer {
  /*border: 1px solid #CCCCCC;*/
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
  -webkit-box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  margin-bottom: 50%;
}

.changePasswordContainer {
  width: 45%;
  margin-right: auto;
  margin-left: auto;
}

.displayText {
  margin-bottom: 0px;
  font-family: Roboto;
}

.passwordUnderline {
  border-bottom: 1px solid #cccccc;
}

.passwordMatched {
  font-size: 14px;
  font-style: italic;
  color: #5aba6a;
  font-family: "Roboto Light";
  letter-spacing: 0.5px;
  margin-top: 0.4rem;
}

.strong {
  padding-left: 0;
  padding-right: 3px;
  margin-bottom: 0;
}

@media only screen and (max-width: 426px) {
  .changePasswordContainer {
    width: auto;
    padding: 0 1.25rem;
    margin-right: auto;
    margin-left: auto;
  }

  .cancelButton,
  .updateButton {
    /* display: inline-block !important; */
    width: 120px !important;
  }
}
</style>
